<form name="Militaryform" (ngSubmit)="f.form.valid && militarysubmit()" #f="ngForm" novalidate>
    <div id="top" class="wrapper   {{formClass}}">
        <!-- <div class="modal-header">
            
        </div> -->
        <div class="modal-body">
            <h2 class="sub-header-text">Military Experience </h2>
            <div class="form-group ">
                <label for="" class="ques-text">Branch of Service</label>
                <!--<select name="military_branch" [(ngModel)]="_parent.model.military_branch" required class="form-control sel-opt">
                    <option value="">Choose your branch</option>
                    <option *ngFor="let branch of branchdata" [value]="branch.branchId">{{ branch.shortName }}</option>
                </select>-->
                <ul class="radio-choice mt-2 mb-0">
                    <li *ngFor='let branch of branchdata'>
                        <label class="radio-container">
                            <input type="radio" [value]="branch.branchId" name="military_branch"
                                [(ngModel)]="_parent.model.military_branch" required>{{ branch.shortName }}
                            <span class="checkmark"></span>
                        </label>
                    </li>
                </ul>
            </div>
            <label for="" class="ques-text">Military status upon enrollment?</label>
            <ul class="radio-choice mt-2 mb-0">
                <li>
                    <label class="radio-container">
                        <input type="radio" value="Active" name="military_status"
                            [(ngModel)]="_parent.model.military_status" required> Active Duty
                        <span class="checkmark"></span>
                    </label>
                </li>
                <li>
                    <label class="radio-container">
                        <input type="radio" value="Guard" name="military_status"
                            [(ngModel)]="_parent.model.military_status" required>National Guard
                        <span class="checkmark"></span>
                    </label>
                </li>
                <li>
                    <label class="radio-container">
                        <input type="radio" value="Reserve" name="military_status"
                            [(ngModel)]="_parent.model.military_status" required>Reserve
                        <span class="checkmark"></span>
                    </label>
                </li>
                <li>
                    <label class="radio-container">
                        <input type="radio" value="Retired" name="military_status"
                            [(ngModel)]="_parent.model.military_status" required>Retiree
                        <span class="checkmark"></span>
                    </label>
                </li>
                <li>
                    <label class="radio-container">
                        <input type="radio" value="Veteran" name="military_status"
                            [(ngModel)]="_parent.model.military_status" required>Veteran
                        <span class="checkmark"></span>
                    </label>
                </li>
                <li>
                    <label class="radio-container">
                        <input type="radio" value="Spouse" name="military_status"
                            [(ngModel)]="_parent.model.military_status" required>Spouse
                        <span class="checkmark"></span>
                    </label>
                </li>
                <li>
                    <label class="radio-container">
                        <input type="radio" value="Dependent" name="military_status"
                            [(ngModel)]="_parent.model.military_status" required>Dependent
                        <span class="checkmark"></span>
                    </label>
                </li>
                <li>
                    <label class="radio-container">
                        <input type="radio" value="Other" name="military_status"
                            [(ngModel)]="_parent.model.military_status" required>Other
                        <span class="checkmark"></span>
                    </label>
                </li>
            </ul>

            <!--radio-choice-->
           
            <div class="error-display" *ngIf="errdisplay">
                <ul class="p-0">
                    <li *ngFor='let msg of errormsg' class="errorclass">{{ msg }}</li>
                </ul>
            </div>
        </div>
        <div class="modal-footer m-footer flex-column">
            <div class="d-flex justify-content-between w-100">
                <a href="javascript:void(0)" (click)="prevAction()" class="btn btn-prev btn-xs">
                    <i class="fas fa-arrow-left"></i> &nbsp; Prev
                </a>
    
                <div class="slider-scroll">
                    <ul>
                        <li class="d-inline">
                            <i class="far fa-circle"></i>
                        </li>
                        <li class="d-inline">
                            <i class="far fa-circle"></i>
                        </li>
                        <li class="d-inline">
                            <i class="far fa-circle"></i>
                        </li>
                        <li class="d-inline">
                            <i class="fas fa-circle"></i>
                        </li>
                        <li class="d-inline">
                            <i class="far fa-circle"></i>
                        </li>
                    </ul>
                </div>
                <a href="javascript:void(0)" (click)="clickSubmit(f.form.valid)" [class.disabled]="isLoader"
                    class="btn btn-next btn-xs">
                    &nbsp;NEXT
                    <i *ngIf="!isLoader" class="fas fa-arrow-right"></i><i *ngIf="isLoader"
                        class="fas fa-circle-notch fa-spin"></i>
                </a>
            </div>
            <div id="footer" class="text-center mt-3">
                <p>© {{ _parent.year }} CollegeRecon. All rights reserved.</p>
             </div>
        </div>
    </div>
</form>


// WEBPACK FOOTER //
// ./src/app/components/pworkflow/military/military.component.html